/* @flow */

import * as React from 'react';

import type {Lead} from '../timeline/types';

import {colors} from '../colors';
import {LeadIconChevron} from '../icon';
import {MiniListPopover} from '../mini-list-popover/mini-list-popover';

import {LeadTwoLine} from './lead-two-line';

import './lead-count-avatar.css';

type Props = {
    leads: Lead[],
    size: number,
};

export function LeadCountAvatar(props: Props) {
    const {leads, size} = props;

    const [shouldShowPopover, setShouldShowPopover] = React.useState<boolean>(false);

    const leadAvatarRef = React.useRef();

    return (
        <>
            <div
                styleName='lead-chevron-container'
                style={{width: size, height: size, borderRadius: size}}
                onMouseOver={() => {
                    setShouldShowPopover(true);
                }}
                onMouseLeave={() => {
                    setShouldShowPopover(false);
                }}
                ref={leadAvatarRef}
            >
                <LeadIconChevron
                    wrapWithDiv={false}
                    size={Math.ceil(size / 1.4)}
                    fill={colors.white}
                />
                <div
                    styleName='count-container'
                    style={{width: size, height: size, fontSize: Math.ceil(size / 2.6)}}
                >
                    <div>{leads.length}</div>
                </div>
            </div>
            {shouldShowPopover ? (
                <MiniListPopover
                    anchor={leadAvatarRef}
                    collection={leads}
                    renderRow={(lead) => (
                        <LeadTwoLine
                            leadName={lead.name}
                            leadNumber={lead.number}
                            avatarUrl={lead.avatarUrl}
                            htmlUrl={lead.htmlUrl}
                            leadStatus={lead.status}
                            priority={lead.priority}
                            relatedPerson={lead.relatedPerson}
                            relatedCompany={lead.relatedCompany}
                            withLessPadding={true}
                            isLinkable={false}
                        />
                    )}
                />
            ) : (
                undefined
            )}
        </>
    );
}
